module.exports = __webpack_public_path__ + "static/media/logo-mini.8539ea86.svg";